// extracted by mini-css-extract-plugin
module.exports = {"root":"Editor_root__nPiGe"};